import _ from 'underscore';
import { useCallback, useContext } from 'react';
import { PreferenceContext } from '@bingads-webui-react/preference-context';
import { usePreference, preferenceNames } from '@bingads-webui-campaign-react/pmax-lite-data';

export function useWizardStepPreference() {
  const preferenceService = useContext(PreferenceContext);
  const [{ value: stepPreference }, { update: updatePreference }]
    = usePreference(preferenceNames.WizardStep);

  const {
    stepId: savedStepId,
    flowFactors: savedFlowFactors,
  } = stepPreference;

  const updateStepPreference = useCallback(({ stepId, flowFactors }) => {
    const newStepPreference = {};

    if (!_.isUndefined(stepId) && stepId !== savedStepId) {
      newStepPreference.stepId = stepId;
    }

    if (!_.isUndefined(flowFactors) && !_.isEqual(flowFactors, savedFlowFactors)) {
      newStepPreference.flowFactors = flowFactors;
    }

    if (!_.isEmpty(newStepPreference) && !_.isEmpty(preferenceService)) {
      updatePreference({
        ...stepPreference,
        ...newStepPreference,
      });
    }
  }, [preferenceService, savedFlowFactors, savedStepId, stepPreference, updatePreference]);

  return [stepPreference, updateStepPreference];
}
